export default __webpack_public_path__ + "static/media/Quiken_Envios_internacionales-05.d41ee625.svg";